export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch {
    return false;
  }
};

export const redirectToUrl = (url) => {
  if (!url) throw new Error('No URL provided');
  if (!isValidUrl(url)) throw new Error('Invalid URL provided', url);
  window.location.href = url;
};

export const isValidSmsParams = (smsParam) => {
  const decodedR = decodeURIComponent(smsParam);
  // Check if starts with 'sms:'
  if (!decodedR.startsWith('sms:')) return false;

  // Extract phone number and body
  const [smsPrefix, bodyParam] = decodedR.split('&');
  const phoneNumber = smsPrefix.replace('sms:', '');

  // Validate phone number exists and body parameter exists
  if (!phoneNumber || !bodyParam) return false;
  if (!bodyParam.startsWith('body=')) return false;

  // Validate phone number format using the shared function
  return isValidPhoneNumber(phoneNumber);
};

export const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  // Allow + prefix, then validate that the rest are only digits
  const cleanNumber = phoneNumber.startsWith('+') ? phoneNumber.slice(1) : phoneNumber;
  return /^\d+$/.test(cleanNumber);
};